// // src/pages/ROB.js
// import React, { useEffect, useState, useRef } from 'react';
// import { Link } from 'react-router-dom';
// import { Helmet } from 'react-helmet';
// import Navbar from '../components/Navbar';
// import Footer from '../components/Footer';
// import imagesLoaded from 'imagesloaded';
// import './OneStepMedi.css';

// const API_URL = 'https://api.securxperts.com:8000';
// const ENDPOINT = '/forms/contact';

// /* -------------------- CONTACT FORM ----------------------- */
// const ContactForm = () => {
//   const [form, setForm] = useState({
//     name: '',
//     email: '',
//     country_code: '',
//     phoneno: '',
//     location: '',
//     purpose: '',
//     message: '',
//   });

//   const [submitting, setSubmitting] = useState(false);
//   const [status, setStatus] = useState(null);

//   const handleChange = (e) =>
//     setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));

//   const validate = () => {
//     if (!form.name.trim()) return 'Name is required';
//     if (!form.email.trim()) return 'Email is required';
//     const emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     if (!emailRe.test(form.email)) return 'Enter a valid email';
//     if (!form.country_code.trim()) return 'Country code is required';
//     if (!form.phoneno.trim()) return 'Phone number is required';
//     if (!form.location.trim()) return 'Location is required';
//     if (!form.purpose.trim()) return 'Purpose is required';
//     if (!form.message.trim()) return 'Message is required';
//     return null;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setStatus(null);

//     const err = validate();
//     if (err) {
//       setStatus({ type: 'error', msg: err });
//       return;
//     }

//     setSubmitting(true);
//     try {
//       const payload = { ...form };

//       const resp = await fetch(`${API_URL}${ENDPOINT}`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(payload),
//       });

//       if (resp.ok) {
//         let data = null;
//         try {
//           data = await resp.json();
//         } catch {
//           // ignore parse errors
//         }
//         setStatus({
//           type: 'success',
//           msg: data?.message || 'Thank you! Your request has been submitted.',
//         });
//         setForm({
//           name: '',
//           email: '',
//           country_code: '',
//           phoneno: '',
//           location: '',
//           purpose: '',
//           message: '',
//         });
//       } else {
//         let errText = `Server responded with ${resp.status}`;
//         try {
//           const json = await resp.json();
//           if (json?.error) errText = json.error;
//           else if (json?.message) errText = json.message;
//         } catch {
//           const txt = await resp.text().catch(() => null);
//           if (txt) errText = txt;
//         }
//         setStatus({ type: 'error', msg: `Submission failed: ${errText}` });
//       }
//     } catch (error) {
//       console.error('ROB contact submit error:', error);
//       setStatus({ type: 'error', msg: 'Network error. Please try again.' });
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   return (
//     <form
//       onSubmit={handleSubmit}
//       className="max-w-3xl mx-auto bg-white/5 p-6 md:p-10 rounded-2xl shadow-lg"
//       aria-label="ROB Enquiry Form"
//     >
//       <h3 className="text-2xl md:text-3xl font-bold text-center mb-6 text-white">
//         Start Using ROB Today
//       </h3>

//       <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//         <input
//           name="name"
//           value={form.name}
//           onChange={handleChange}
//           placeholder="Full Name"
//           required
//           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none"
//         />

//         <input
//           name="email"
//           type="email"
//           value={form.email}
//           onChange={handleChange}
//           placeholder="Email"
//           required
//           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none"
//         />

//         <input
//           name="country_code"
//           value={form.country_code}
//           onChange={handleChange}
//           placeholder="Country Code (e.g. +44)"
//           required
//           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none"
//         />

//         <input
//           name="phoneno"
//           value={form.phoneno}
//           onChange={handleChange}
//           placeholder="Phone Number"
//           type="tel"
//           required
//           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none"
//         />

//         <input
//           name="location"
//           value={form.location}
//           onChange={handleChange}
//           placeholder="Organisation Location (City, Country)"
//           required
//           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none md:col-span-2"
//         />

//         <input
//           name="purpose"
//           value={form.purpose}
//           onChange={handleChange}
//           placeholder="Purpose (Campus / Corporate / Training / Pilot)"
//           required
//           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none md:col-span-2"
//         />

//         <textarea
//           name="message"
//           value={form.message}
//           onChange={handleChange}
//           placeholder="Tell us about your recruitment or onboarding workflows"
//           rows={4}
//           required
//           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none md:col-span-2 resize-none"
//         />
//       </div>

//       <button
//         type="submit"
//         disabled={submitting}
//         className="bg-blue-600 hover:bg-blue-700 transition px-6 py-3 rounded-full font-semibold w-full mt-6 disabled:opacity-50"
//       >
//         {submitting ? 'Submitting...' : 'Start Using ROB Today'}
//       </button>

//       {status && (
//         <p
//           role="status"
//           className={`text-center mt-4 text-sm ${
//             status.type === 'success' ? 'text-green-400' : 'text-red-400'
//           }`}
//         >
//           {status.msg}
//         </p>
//       )}

//       <p className="text-xs mt-4 text-white/60 text-center">
//         Your details will remain confidential and used only for enquiry purposes.
//       </p>
//     </form>
//   );
// };

// /* -------------------- MAIN PAGE ----------------------- */
// const ROB = () => {
//   const [isLoading, setIsLoading] = useState(true);
//   const [showScroll, setShowScroll] = useState(false);
//   const [scrollProgress, setScrollProgress] = useState(0);

//   // 🔁 Ref for hero video
//   const heroVideoRef = useRef(null);

//   // Image load -> hide loading screen
//   useEffect(() => {
//     imagesLoaded(
//       document.querySelectorAll('.content__item-img'),
//       { background: true },
//       () => {
//         document.body.classList.remove('loading');
//         setIsLoading(false);
//       }
//     );
//   }, []);

//   // Parallax scroll for cards
//   useEffect(() => {
//     const items = document.querySelectorAll('.content__item');

//     const handleScroll = () => {
//       items.forEach((item) => {
//         const img = item.querySelector('.content__item-img');
//         const wrapper = img?.parentNode;
//         if (!img || !wrapper) return;

//         const rect = item.getBoundingClientRect();
//         const progress = Math.min(
//           Math.max(
//             (window.innerHeight - rect.top) / (window.innerHeight + rect.height),
//             0
//           ),
//           1
//         );

//         const translateY = progress * 100 - 50;
//         const rotate = progress * -45;

//         img.style.transform = `translateY(${translateY}px)`;
//         wrapper.style.transform = `rotate3d(1, 0.3, 0.1, ${rotate}deg)`;
//       });
//     };

//     window.addEventListener('scroll', handleScroll);
//     handleScroll();
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   // Circular scroll progress button visibility & progress
//   useEffect(() => {
//     const circumference = 307.919;
//     const handleProgress = () => {
//       const scrollTop = window.scrollY || document.documentElement.scrollTop;
//       const docHeight = document.documentElement.scrollHeight - window.innerHeight;
//       const progress =
//         docHeight > 0 ? Math.min(Math.max(scrollTop / docHeight, 0), 1) : 0;
//       setScrollProgress(circumference * progress);
//       setShowScroll(scrollTop > 600);
//     };

//     window.addEventListener('scroll', handleProgress);
//     handleProgress();
//     return () => window.removeEventListener('scroll', handleProgress);
//   }, []);

//   // 🔁 Restart hero video when user scrolls back to top
//   useEffect(() => {
//     let wasNotAtTop = false;

//     const handleVideoReset = () => {
//       const scrollTop = window.scrollY || document.documentElement.scrollTop;
//       const isAtTop = scrollTop < 50;

//       // Only reset when transitioning from away-from-top → at-top
//       if (isAtTop && wasNotAtTop && heroVideoRef.current) {
//         heroVideoRef.current.currentTime = 0;
//         heroVideoRef.current.play().catch(() => {});
//       }

//       wasNotAtTop = !isAtTop;
//     };

//     window.addEventListener('scroll', handleVideoReset);
//     handleVideoReset(); // initial check

//     return () => window.removeEventListener('scroll', handleVideoReset);
//   }, []);

//   const scrollToTop = () => {
//     window.scrollTo({ top: 0, behavior: 'smooth' });

//     // Also restart video when using the scroll-to-top button
//     if (heroVideoRef.current) {
//       heroVideoRef.current.currentTime = 0;
//       heroVideoRef.current.play().catch(() => {});
//     }
//   };

//   return (
//     <>
//       <Helmet>
//         <title>ROB | Smart Recruitment & Onboarding Platform</title>
//         <meta
//           name="description"
//           content="ROB is a UK-focused platform to streamline recruitment and onboarding for businesses and institutions, with candidate evaluation, live assessments, interview coordination and analytics."
//         />
//       </Helmet>

//       {/* Loading Screen */}
//       <div
//         className={`fixed inset-0 bg-black flex items-center justify-center z-50 transition-opacity duration-1000 ${
//           isLoading ? 'opacity-100' : 'opacity-0 pointer-events-none'
//         }`}
//       >
//         <h1 className="text-4xl md:text-6xl font-bold text-white animate-pulse text-center px-4">
//           ROB – Smart Recruitment & Onboarding
//         </h1>
//       </div>

//       {/* Navbar */}
//       <Navbar />

//       {/* Hero Video Section */}
//       <section className="relative h-screen">
//         <video
//           ref={heroVideoRef}
//           className="absolute inset-0 w-full h-full object-cover"
//           autoPlay
//           loop
//           muted
//           playsInline
//         >
//           <source src="/video/ROB N GRAB .mp4" type="video/mp4" />
//         </video>
//         <div className="absolute inset-0 bg-black/60" />
//       </section>

//       {/* Main Content with Parallax */}
//       <main className="bg-black text-white">
//         <div className="content content--padded">
//           {/* Features Section */}
//           <section className="py-12 max-w-5xl mx-auto text-left px-6">
//             <h2 className="text-3xl md:text-4xl font-extrabold mb-6">
//               Key Features of ROB
//             </h2>

//             {/* Candidate Evaluation & Shortlisting */}
//             <div className="mb-8">
//               <h3 className="text-2xl md:text-3xl font-bold mb-3">
//                 Candidate Evaluation &amp; Shortlisting
//               </h3>
//               <p className="text-base md:text-lg">
//                 Screen applicants based on skills, experience, qualifications, or assessment results. Rank and
//                 shortlist candidates efficiently with structured evaluation tools.
//               </p>
//             </div>

//             {/* Vacancy Management & Talent Sourcing */}
//             <div className="mb-8">
//               <h3 className="text-2xl md:text-3xl font-bold mb-3">
//                 Vacancy Management &amp; Talent Sourcing
//               </h3>
//               <p className="text-base md:text-lg">
//                 Create roles or internship programmes and distribute them across multiple channels. Receive
//                 applications directly within ROB for consistent, centralised evaluation.
//               </p>
//             </div>

//             {/* Live Skill Assessments & Coding Tests */}
//             <div className="mb-8">
//               <h3 className="text-2xl md:text-3xl font-bold mb-3">
//                 Live Skill Assessments &amp; Coding Tests
//               </h3>
//               <p className="text-base md:text-lg">
//                 Conduct real-time coding challenges, MCQs or skill-based tests in a single session. Auto-grading
//                 ensures objective results and fair, data-backed comparison.
//               </p>
//             </div>

//             {/* Interview Coordination & Collaboration */}
//             <div className="mb-8">
//               <h3 className="text-2xl md:text-3xl font-bold mb-3">
//                 Interview Coordination &amp; Collaboration
//               </h3>
//               <p className="text-base md:text-lg">
//                 Schedule interviews with automated calendar integration. Notify interviewers and candidates via
//                 email or messaging, and centralise feedback within ROB.
//               </p>
//             </div>

//             {/* Offer Issuance & Onboarding Guidance */}
//             <div className="mb-8">
//               <h3 className="text-2xl md:text-3xl font-bold mb-3">
//                 Offer Issuance &amp; Onboarding Guidance
//               </h3>
//               <p className="text-base md:text-lg">
//                 Generate offer letters, collect digital acceptance, and guide new hires through a structured
//                 onboarding checklist for a consistent first-day experience.
//               </p>
//             </div>

//             {/* Secure Records & Compliance Hub */}
//             <div className="mb-8">
//               <h3 className="text-2xl md:text-3xl font-bold mb-3">
//                 Secure Records &amp; Compliance Hub
//               </h3>
//               <p className="text-base md:text-lg">
//                 Store candidate and employee data, assessment outcomes, and approvals securely in a central hub,
//                 supporting compliance and audit requirements.
//               </p>
//             </div>

//             {/* Insights & Reporting Dashboard */}
//             <div className="mb-2">
//               <h3 className="text-2xl md:text-3xl font-bold mb-3">
//                 Insights &amp; Reporting Dashboard
//               </h3>
//               <p className="text-base md:text-lg">
//                 Generate pipeline summaries, assessment analytics, onboarding progress and completion metrics to
//                 understand hiring performance and improve decision-making.
//               </p>
//             </div>
//           </section>

//           {/* Parallax Cards – ROB visuals */}
//           <div
//             className="content__item content__item--expand"
//             style={{ ['--aspect-ratio']: '7/5' }}
//           >
//             <div className="content__item-imgwrap">
//               <div
//                 className="content__item-img"
//                 style={{ backgroundImage: "url('/img/rob-candidates.jpg')" }}
//               />
//             </div>
//             <h2 className="content__item-title">Structured Candidate Evaluation</h2>
//             <p className="content__item-description">
//               Standardise how you review CVs, scores and feedback so shortlisting is consistent and transparent
//               across all roles.
//             </p>
//           </div>

//           <div
//             className="content__item content__item--expand"
//             style={{ ['--aspect-ratio']: '7/5' }}
//           >
//             <div className="content__item-imgwrap">
//               <div
//                 className="content__item-img"
//                 style={{ backgroundImage: "url('/img/rob-assessments.jpg')" }}
//               />
//             </div>
//             <h2 className="content__item-title">Live Skills & Coding Assessments</h2>
//             <p className="content__item-description">
//               Host secure online tests with auto-grading, ensuring fair comparison across candidates and cohorts.
//             </p>
//           </div>

//           <div
//             className="content__item content__item--expand"
//             style={{ ['--aspect-ratio']: '7/5' }}
//           >
//             <div className="content__item-imgwrap">
//               <div
//                 className="content__item-img"
//                 style={{ backgroundImage: "url('/img/rob-onboarding.jpg')" }}
//               />
//             </div>
//             <h2 className="content__item-title">Guided Onboarding Journeys</h2>
//             <p className="content__item-description">
//               Move new hires from offer to fully onboarded with guided checklists, tasks and documentation flows.
//             </p>
//           </div>

//           <div
//             className="content__item content__item--expand"
//             style={{ ['--aspect-ratio']: '7/5' }}
//           >
//             <div className="content__item-imgwrap">
//               <div
//                 className="content__item-img"
//                 style={{ backgroundImage: "url('/img/rob-analytics.jpg')" }}
//               />
//             </div>
//             <h2 className="content__item-title">Recruitment Analytics &amp; Insights</h2>
//             <p className="content__item-description">
//               Monitor funnel health, hiring velocity and conversion rates with dashboards tailored for HR and
//               leadership.
//             </p>
//           </div>

//           {/* CTA */}
//           <section className="text-center py-32">
//             <h2 className="text-4xl md:text-7xl font-bold mb-6">
//               ROB — The Future of Recruitment &amp; Onboarding
//             </h2>
//             <p className="text-base md:text-xl text-white/80 max-w-3xl mx-auto mb-8">
//               Bring every part of your recruitment and onboarding journey into one intelligent, UK-focused
//               platform built for campuses and corporates alike.
//             </p>
//             <div className="space-x-8">
//               <a
//                 href="#contact"
//                 className="inline-block bg-blue-600 text-white px-10 py-5 rounded-full text-2xl font-bold hover:bg-blue-700 transition transform hover:scale-110"
//               >
//                 Start Using ROB Today
//               </a>
//             </div>
//           </section>

//           {/* Contact section */}
//           <section id="contact" className="py-16 bg-gradient-to-b from-black to-gray-900">
//             <div className="max-w-6xl mx-auto px-6">
//               <h3 className="text-3xl md:text-4xl font-extrabold text-center mb-6">
//                 Talk to Our ROB Implementation Team
//               </h3>
//               <p className="text-center text-white/70 mb-8">
//                 Share your recruitment and onboarding goals — whether for graduate programmes, internships or
//                 lateral hiring — and we’ll help you roll out ROB in the best possible way.
//               </p>

//               <ContactForm />
//             </div>
//           </section>
//         </div>
//       </main>

//       {/* Footer */}
//       <Footer />

//       {/* Scroll to Top Button (arrow) */}
//       <button
//         onClick={scrollToTop}
//         className="scrollToTopBtn fixed bottom-10 right-10 z-50 opacity-0 transition-all duration-700"
//       >
//         <svg className="w-16 h-16 text-white drop-shadow-2xl" viewBox="0 0 512 512">
//           <path fill="currentColor" d="M256 108L109 296l37 37 90-90v210h48V243l90 90 37-37z" />
//         </svg>
//       </button>

//       {/* Circular Scroll Progress Button */}
//       {showScroll && (
//         <div
//           onClick={scrollToTop}
//           className="scroll-top fixed bottom-6 right-6 z-50 cursor-pointer flex items-center justify-center w-14 h-14 rounded-full bg-gradient-to-r from-blue-500 to-blue-700 shadow-lg hover:from-blue-600 hover:to-blue-800 transition-all"
//         >
//           <svg className="progress-circle -rotate-90 w-12 h-12 absolute" viewBox="-1 -1 102 102">
//             <path
//               d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
//               fill="none"
//               stroke="white"
//               strokeWidth="4"
//               strokeDasharray="307.919"
//               strokeDashoffset={307.919 - scrollProgress}
//               style={{ transition: 'stroke-dashoffset 0.1s linear' }}
//             />
//           </svg>
//           <svg
//             xmlns="http://www.w3.org/2000/svg"
//             className="w-6 h-6 text-white relative z-10"
//             fill="none"
//             viewBox="0 0 24 24"
//             stroke="currentColor"
//             strokeWidth={2}
//           >
//             <path strokeLinecap="round" strokeLinejoin="round" d="M5 15l7-7 7 7" />
//           </svg>
//         </div>
//       )}
//     </>
//   );
// };

// export default ROB;








import React, { useState, useEffect, useRef } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Flag from 'react-country-flag'; // npm install react-country-flag

const API_URL = "https://api.securxperts.com:8000";
const ENDPOINT = "/forms/contact";

// ====================== COUNTRIES DATA ======================
const COUNTRIES = [
  { code: "+91", name: "India", iso: "IN" },
  { code: "+1", name: "United States", iso: "US" },
  { code: "+44", name: "United Kingdom", iso: "GB" },
  { code: "+61", name: "Australia", iso: "AU" },
  { code: "+971", name: "United Arab Emirates", iso: "AE" },
  // Add more countries if needed
];

// ====================== COUNTRY DROPDOWN ======================
const CountryDropdown = ({ value, onChange, error, touched }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState("");
  const dropdownRef = useRef(null);

  const filteredCountries = COUNTRIES.filter(
    (c) =>
      c.code.includes(search) ||
      c.name.toLowerCase().includes(search.toLowerCase())
  );

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const selected = COUNTRIES.find((c) => c.code === value) || null;

  return (
    <div className="relative w-full" ref={dropdownRef}>
      <div
        className={`w-full p-3 rounded-lg border cursor-pointer flex items-center gap-2 transition-all ${
          error && touched
            ? "border-orange-400 bg-orange-50"
            : "border-gray-300 hover:border-gray-400"
        }`}
        onClick={() => setIsOpen(!isOpen)}
      >
        {selected ? (
          <>
            <Flag countryCode={selected.iso} svg style={{ width: '24px', height: '16px', borderRadius: '2px' }} />
            <span className="font-medium">{selected.code}</span>
          </>
        ) : (
          <span className="text-gray-500">Country Code</span>
        )}
        <span className="ml-auto text-gray-400">▼</span>
      </div>

      {isOpen && (
        <div className="absolute z-50 w-full mt-1 bg-white border rounded-lg shadow-lg max-h-64 overflow-auto">
          <input
            type="text"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Search country or code..."
            className="w-full p-2 border-b focus:outline-none"
            autoFocus
          />
          {filteredCountries.map((country) => (
            <div
              key={country.code}
              className="p-2 hover:bg-gray-100 cursor-pointer flex items-center gap-2"
              onClick={() => {
                onChange({ target: { name: "country_code", value: country.code } });
                setIsOpen(false);
                setSearch("");
              }}
            >
              <Flag countryCode={country.iso} svg style={{ width: '24px', height: '16px', borderRadius: '2px' }} />
              <span>{country.code}</span>
              <span className="text-gray-500 text-sm ml-2">{country.name}</span>
            </div>
          ))}
        </div>
      )}

      {error && touched && <p className="mt-1 text-sm text-orange-600">{error}</p>}
    </div>
  );
};

// ====================== SUCCESS POPUP ======================
const SuccessPopup = ({ isOpen, onClose }) => {
  const timeoutRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      timeoutRef.current = setTimeout(onClose, 5000);
    }
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl p-8 max-w-sm w-full shadow-2xl relative animate-in fade-in zoom-in duration-200">
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-800 text-2xl"
        >
          ×
        </button>
        <div className="text-center">
          <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          </div>
          <h3 className="text-xl font-bold mb-2">Success!</h3>
          <p className="text-gray-600">Your request has been submitted successfully.</p>
        </div>
      </div>
    </div>
  );
};

/* ----------------------------------------------------
   IMPROVED CONTACT FORM
----------------------------------------------------- */
const ContactForm = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    country_code: "",
    phoneno: "",
    location: "",
    purpose: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});
  const [isValid, setIsValid] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  const validateField = (name, value) => {
    switch (name) {
      case "name":
        if (!value.trim()) return "Name is required";
        return "";
      case "email":
        if (!value.trim()) return "Email is required";
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) return "Invalid email";
        return "";
      case "country_code":
        if (!value) return "Country code is required";
        return "";
      case "phoneno":
        if (!value.trim()) return "Phone number is required";
        if (value.length !== 10) return "Must be exactly 10 digits";
        return "";
      case "location":
      case "purpose":
      case "message":
        if (!value.trim()) return "This field is required";
        return "";
      default:
        return "";
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    let newValue = value;

    // Phone number cleaning
    if (name === "phoneno") {
      newValue = value.replace(/\D/g, "").slice(0, 10);
    }

    // Name / location / purpose - only letters + spaces
    if (["name", "location", "purpose"].includes(name)) {
      newValue = value.replace(/[^a-zA-Z\s]/g, "");
    }

    setForm((prev) => ({ ...prev, [name]: newValue }));
    setTouched((prev) => ({ ...prev, [name]: true }));

    const error = validateField(name, newValue);
    setErrors((prev) => ({ ...prev, [name]: error }));
  };

  useEffect(() => {
    const requiredFields = ["name", "email", "country_code", "phoneno", "location", "purpose", "message"];
    const allFilled = requiredFields.every((f) => form[f]?.trim());
    const noErrors = Object.values(errors).every((e) => !e);
    setIsValid(allFilled && noErrors);
  }, [form, errors]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!isValid) return;

    setSubmitting(true);

    try {
      const resp = await fetch(`${API_URL}${ENDPOINT}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });

      if (resp.ok) {
        setShowSuccess(true);
        // Reset form
        setForm({
          name: "", email: "", country_code: "", phoneno: "",
          location: "", purpose: "", message: "",
        });
        setErrors({});
        setTouched({});
      } else {
        alert("Submission failed. Please try again.");
      }
    } catch (err) {
      alert("Network error. Please try again later.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <form
        onSubmit={handleSubmit}
        className="max-w-3xl mx-auto bg-white p-6 md:p-10 rounded-2xl shadow-lg border"
      >
        <h3 className="text-3xl font-bold text-center mb-8">
          Start Using ROB Today
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {/* Name */}
          <div>
            <input
              name="name"
              value={form.name}
              onChange={handleChange}
              placeholder="Full Name *"
              className={`w-full p-3 rounded-lg border outline-none transition-all ${
                errors.name && touched.name ? "border-orange-400" : "border-gray-300 hover:border-gray-400"
              }`}
            />
            {errors.name && touched.name && (
              <p className="mt-1 text-sm text-orange-600">{errors.name}</p>
            )}
          </div>

          {/* Email */}
          <div>
            <input
              name="email"
              type="email"
              value={form.email}
              onChange={handleChange}
              placeholder="Email *"
              className={`w-full p-3 rounded-lg border outline-none transition-all ${
                errors.email && touched.email ? "border-orange-400" : "border-gray-300 hover:border-gray-400"
              }`}
            />
            {errors.email && touched.email && (
              <p className="mt-1 text-sm text-orange-600">{errors.email}</p>
            )}
          </div>

          {/* Country Code */}
          <div>
            <CountryDropdown
              value={form.country_code}
              onChange={handleChange}
              error={errors.country_code}
              touched={touched.country_code}
            />
          </div>

          {/* Phone */}
          <div>
            <input
              name="phoneno"
              value={form.phoneno}
              onChange={handleChange}
              placeholder="Phone Number *"
              maxLength={10}
              className={`w-full p-3 rounded-lg border outline-none transition-all ${
                errors.phoneno && touched.phoneno ? "border-orange-400" : "border-gray-300 hover:border-gray-400"
              }`}
            />
            {errors.phoneno && touched.phoneno && (
              <p className="mt-1 text-sm text-orange-600">{errors.phoneno}</p>
            )}
          </div>

          {/* Location */}
          <div className="md:col-span-2">
            <input
              name="location"
              value={form.location}
              onChange={handleChange}
              placeholder="Organisation Location *"
              className={`w-full p-3 rounded-lg border outline-none transition-all ${
                errors.location && touched.location ? "border-orange-400" : "border-gray-300 hover:border-gray-400"
              }`}
            />
            {errors.location && touched.location && (
              <p className="mt-1 text-sm text-orange-600">{errors.location}</p>
            )}
          </div>

          {/* Purpose */}
          <div className="md:col-span-2">
            <input
              name="purpose"
              value={form.purpose}
              onChange={handleChange}
              placeholder="Purpose (Campus, Corporate, Training) *"
              className={`w-full p-3 rounded-lg border outline-none transition-all ${
                errors.purpose && touched.purpose ? "border-orange-400" : "border-gray-300 hover:border-gray-400"
              }`}
            />
            {errors.purpose && touched.purpose && (
              <p className="mt-1 text-sm text-orange-600">{errors.purpose}</p>
            )}
          </div>

          {/* Message */}
          <div className="md:col-span-2">
            <textarea
              name="message"
              value={form.message}
              onChange={handleChange}
              placeholder="Tell us about your hiring process *"
              rows={4}
              className={`w-full p-3 rounded-lg border outline-none transition-all resize-none ${
                errors.message && touched.message ? "border-orange-400" : "border-gray-300 hover:border-gray-400"
              }`}
            />
            {errors.message && touched.message && (
              <p className="mt-1 text-sm text-orange-600">{errors.message}</p>
            )}
          </div>
        </div>

        <button
          type="submit"
          disabled={submitting || !isValid}
          className={`w-full mt-8 py-3 rounded-full text-white font-medium transition-all ${
            isValid && !submitting
              ? "bg-blue-600 hover:bg-blue-700"
              : "bg-gray-400 cursor-not-allowed"
          }`}
        >
          {submitting ? "Submitting..." : "Start Using ROB Today"}
        </button>
      </form>

      {/* Success Popup */}
      <SuccessPopup
        isOpen={showSuccess}
        onClose={() => setShowSuccess(false)}
      />
    </>
  );
};

/* ----------------------------------------------------
   MAIN PAGE (YOUR FULL UI – UNCHANGED)
----------------------------------------------------- */
function Rob() {
  return (
    <div className="w-full mt-10 font-sans text-[#0a1e42] overflow-hidden">
    <div className="fixed top-0 left-0 w-full z-[9999]">
  <Navbar />
</div>


      {/* ----------------- HERO SECTION ----------------- */}
      <section className="w-full bg-gradient-to-br from-blue-50 to-white py-8 px-6 md:px-16">
        <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-10 items-center mt-[-80px]">
          {/* LEFT TEXT */}
          <div>
            <img src="/img/92.png" alt="Logo" className="w-32 mb-6" />
            <h1 className="text-4xl font-bold leading-tight mb-4">
              Smart Recruitment & Onboarding Platform
            </h1>
            <p className="text-gray-600 mb-8">
              A smart platform that streamlines recruitment and onboarding for businesses, universities, colleges and training providers.
            </p>
          </div>

          {/* RIGHT IMAGE */}
          <div className="flex justify-center">
            <img
              src="/img/robimg.png"
              alt="Monitoring Dashboard"
              className="w-100 md:w-96 rounded-xl mt-32"
            />
          </div>
        </div>
      </section>

      {/* ----------------- VIDEO SECTION ----------------- */}
      <section className="w-full py-20 px-6 md:px-0 bg-gray-50">
        <div className="max-w-7xl mx-auto">
                            <div className="max-w-3xl mx-auto mb-10 text-center">
    <h2 className="text-3xl font-bold text-[#063852]">
             Recruitment & Onboarding Simplified
            </h2>
            <p className="text-gray-600 mt-3">
           Experience a smarter way to manage recruitment and onboarding for businesses and institutions. It reduces manual work, improves collaboration, and ensures a smooth experience for every new joiner.
            </p>
            </div>
          <div className="relative rounded-2xl overflow-hidden shadow-2xl group">
            <video
              className="w-full block"
              src="/video/robngrab.mp4"
              autoPlay
              loop
              muted
              playsInline
              preload="auto"
              controls={false}
              key="rob-video"
              onClick={(e) =>
                e.currentTarget.paused
                  ? e.currentTarget.play()
                  : e.currentTarget.pause()
              }
            ></video>
          </div>
        </div>
      </section>

      {/* ----------------- BEYOND THE RESUME ----------------- */}
      <section className="w-full py-4 px-6 md:px-20">
        <h2 className="text-4xl font-extrabold text-center mb-4">
          Key Advantages of Using a Smart Recruitment Platform
        </h2>
        <p className="text-center text-gray-600 max-w-2xl mx-auto mb-14">
          Hire Smarter, Onboard Faster, and Engage Better Talent for a More Productive Workplace
        </p>

        <div className="grid md:grid-cols-3 gap-12 max-w-6xl mx-auto">
          <div className="text-center">
            <img src="/img/streamlinedhiring.png" className="w-16 mx-auto mb-4" />
            <h3 className="text-xl font-bold mb-2">Streamlined Hiring Workflows</h3>
            <p className="text-gray-600 text-sm">
              Manage job postings, candidate shortlisting, interviews and assessments all in one central platform.
            </p>
          </div>

          <div className="text-center">
            <img src="/img/efficientonboarding.png" className="w-16 mx-auto mb-4" />
            <h3 className="text-xl font-bold mb-2">Efficient Onboarding</h3>
            <p className="text-gray-600 text-sm">
              Automate onboarding tasks, checklists, and probation tracking to give new hires a smooth start.
            </p>
          </div>

          <div className="text-center">
            <img src="/img/improvedhr.png" className="w-16 mx-auto mb-4" />
            <h3 className="text-xl font-bold mb-2">Improved HR Productivity</h3>
            <p className="text-gray-600 text-sm">
              Reduce manual work for HR teams and hiring managers, allowing them to focus on strategic tasks.
            </p>
          </div>
        </div>
      </section>

      {/* ----------------- PERSONALIZED SERVICES ----------------- */}
      <section className="w-full py-24 px-6 md:px-20 bg-white mb-8">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          <div>
            <img src="/img/report.png" className="rounded-2xl shadow-2xl w-full mb-[-100px]" />
          </div>

          <div className="mt-16">
            <h2 className="text-4xl font-extrabold mb-6">
              Innovative Smart Recruitment & Onboarding Platform
            </h2>

            <div className="space-y-8">
              <div>
                <h3 className="text-xl font-bold mb-1">Automated Recruitment Workflows</h3>
                <p className="text-gray-600 text-sm">
                  Manage job postings, candidate shortlisting, interviews and assessments in a single intelligent platform, reducing manual effort and speeding up hiring.
                </p>
              </div>

              <div>
                <h3 className="text-xl font-bold mb-1">Expert Ads</h3>
                <p className="text-gray-600 text-sm">
                  Gain attention with professionally optimized job ads.
                </p>
              </div>

              <div>
                <h3 className="text-xl font-bold mb-1">Seamless Onboarding Experience</h3>
                <p className="text-gray-600 text-sm">
                  Automate onboarding tasks, checklists, document collection and probation tracking, giving new hires a smooth and structured start.
                </p>
              </div>

              <div>
                <h3 className="text-xl font-bold mb-1">Enhanced HR Productivity</h3>
                <p className="text-gray-600 text-sm">
                  Reduce repetitive administrative tasks for HR teams and hiring managers, allowing them to focus on strategic initiatives and employee engagement.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ----------------- KEY FEATURES SECTION ----------------- */}
      <section className="w-full py-24 px-6 md:px-20 bg-[#f7f9ff]">
        <div className="max-w-5xl mx-auto bg-white rounded-2xl shadow-xl p-12">
          <h2 className="text-3xl font-bold mb-10">
            Key Features of ROB Recruitment & Onboarding Platform
          </h2>

          <div className="grid md:grid-cols-2 gap-12">
            <div className="flex gap-4">
              <img src="/img/candidatescreening (1).png" className="w-12 h-12" />
              <div>
                <h3 className="font-semibold text-lg">Candidate Screening & Shortlisting</h3>
                <p className="text-gray-600 text-sm">
                  Efficiently evaluate applicants based on skills, experience and qualifications. Rank and shortlist top candidates for faster decision-making.
                </p>
              </div>
            </div>

            <div className="flex gap-4">
              <img src="/img/rolenvacancy.png" className="w-12 h-12" />
              <div>
                <h3 className="font-semibold text-lg">Role & Vacancy Management</h3>
                <p className="text-gray-600 text-sm">
                  Create job roles, internship programmes or openings and share across multiple channels. Receive applications directly within ROB for centralised management.
                </p>
              </div>
            </div>

            <div className="flex gap-4">
              <img src="/img/skillassessments.png" className="w-12 h-12" />
              <div>
                <h3 className="font-semibold text-lg">Skill Assessments & Testing</h3>
                <p className="text-gray-600 text-sm">
                  Conduct real-time assessments, coding challenges or skill-based tests. Auto-grading ensures objective results and fair candidate comparison.
                </p>
              </div>
            </div>

            <div className="flex gap-4">
              <img src="/img/improvedhr.png" className="w-12 h-12" />
              <div>
                <h3 className="font-semibold text-lg">Interview Scheduling & Coordination</h3>
                <p className="text-gray-600 text-sm">
                  Automate interview scheduling with calendar integration. Notify candidates and interviewers via email or messaging for seamless coordination.
                </p>
              </div>
            </div>
          </div>

          {/* <div className="mt-14 bg-[#eef4ff] p-8 rounded-2xl border">
            <h3 className="font-bold text-xl mb-4">AI Resume Score</h3>
            <p className="text-gray-600 text-sm mb-6 max-w-md">
              Upload your resume and instantly receive actionable insights.
            </p>
            <img src="/img/resumeimg.png" className="w-full rounded-xl" />
          </div> */}
        </div>
      </section>

      {/* ----------------- CONTACT FORM ABOVE FOOTER ----------------- */}
      <section className="w-full py-24 px-6 md:px-20 bg-gray-100">
        <h2 className="text-4xl font-extrabold text-center mb-4">
          Talk to Our ROB Implementation Team
        </h2>
        <p className="text-center text-gray-600 max-w-xl mx-auto mb-10">
          Share your goals and we’ll help you implement ROB for your organisation.
        </p>

        <ContactForm />
      </section>

      <Footer />
    </div>
  );
}

export default Rob; 